export default __webpack_public_path__ + "static/media/IMG_20190508_161259.36c271bb.jpg";